module.exports = __webpack_public_path__ + "static/media/allied-irish-bank.a14bdf05.png";